import { RESPONDENT_API_BASE_PATH } from './constants'

export const isURL = (url: string) => url.includes('http')

export const getLegacyApiUrlEndpoint = () => {
  const { REACT_APP_URL_RESPONDENT_API, REACT_APP_DOMAIN } = process.env

  const reactAppUrlRespondentApi =
    REACT_APP_URL_RESPONDENT_API || RESPONDENT_API_BASE_PATH

  return `${
    isURL(reactAppUrlRespondentApi) ? '' : REACT_APP_DOMAIN
  }${reactAppUrlRespondentApi}`
}

export const legacyApiUrlEndpoint = getLegacyApiUrlEndpoint()

export const isAndroid = (): boolean => {
  // Get user agent and normalize to lowercase for consistent matching
  const ua = (navigator.userAgent || '').toLowerCase()

  // Check modern User-Agent Client Hints API (also normalize)
  const uaPlat = (
    (navigator as any).userAgentData?.platform || ''
  ).toLowerCase()

  // Primary Android detection
  if (ua.includes('android') || uaPlat.includes('android')) {
    return true
  }

  // Exclude desktop platforms first to avoid false positives
  if (
    ua.includes('windows') ||
    ua.includes('macintosh') ||
    ua.includes('mac os x') ||
    ua.includes('x11') ||
    uaPlat.includes('windows') ||
    uaPlat.includes('macos') ||
    uaPlat.includes('linux')
  ) {
    return false
  }

  // Additional mobile-specific checks only after excluding desktop
  return (
    // Linux + Mobile (but not desktop Linux)
    (ua.includes('linux') &&
      ua.includes('mobile') &&
      !ua.includes('desktop')) ||
    // WebView but exclude desktop Chrome
    (ua.includes('wv') && ua.includes('chrome') && ua.includes('mobile'))
  )
}
